import React, { useState, useEffect } from "react";
import "./Toggle.scss";
import { ToggleProps } from "../types";

const Toggle: React.FC<ToggleProps> = ({ darkMode, setMode, simulateMouseClick }) => {
    const [localDarkMode, setLocalDarkMode] = useState<boolean>(darkMode);

    useEffect(() => {
        setLocalDarkMode(darkMode);
    }, [darkMode]);

    const handleClick = (): void => {
        if (localDarkMode) {
            document.body.style.backgroundColor = "#10131c";
        } else {
            document.body.style.backgroundColor = "#000";
        }
        setMode();
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            className="toggleWrapper"
            tabIndex={0}
            onKeyDown={handleKeyDown}
            role="button"
            aria-label={`Switch to ${localDarkMode ? 'light' : 'dark'} mode`}
            style={{
                // Safari dark mode fix: force light color scheme
                colorScheme: 'light only',
                WebkitColorScheme: 'light only',
            } as React.CSSProperties}
        >
            <input
                type="checkbox"
                className="dn"
                id="dn"
                checked={localDarkMode}
                onChange={() => { }} // Read-only, controlled by parent
            />
            <label
                htmlFor="dn"
                className="toggle"
                onClick={handleClick}
                style={{
                    // Safari dark mode fix: ensure exact colors
                    colorScheme: 'light only',
                    WebkitColorScheme: 'light only',
                    WebkitPrintColorAdjust: 'exact',
                    printColorAdjust: 'exact',
                } as React.CSSProperties}
            >
                <span 
                    className="toggle__handler"
                    style={{
                        // Safari dark mode fix: ensure exact colors
                        colorScheme: 'light only',
                        WebkitPrintColorAdjust: 'exact',
                    } as React.CSSProperties}
                >
                    <span className="crater crater--1"></span>
                    <span className="crater crater--2"></span>
                    <span className="crater crater--3"></span>
                </span>
                <span className="star star--1"></span>
                <span className="star star--2"></span>
                <span className="star star--3"></span>
                <span className="star star--4"></span>
                <span className="star star--5"></span>
                <span className="star star--6"></span>
            </label>
        </div>
    );
};

export default Toggle;
